import ManagerRepository from 'coreClasses/ManagerRepository';
import {loadScript} from 'coreUtils/utils';

const AMAZON_SCRIPT_ID = 'amazon-pay-script';

/**
 * Fetch data about Amazon Pay
 * @param managerRepository - manager repository
 * @returns Promise with config
 */
export function fetchAmazonConfig(managerRepository: ManagerRepository): Promise<any> {
	return managerRepository.getSfccAPI().amazonPayApplicable();
}

/**
 * Adds Amazon script to the page
 * @param scriptUrl - url of the script
 * @param scriptId - id of <script> DOM element
 * @returns Promise
 */
export function addAmazonScript(scriptUrl: string): Promise<unknown> {
	return loadScript(scriptUrl, AMAZON_SCRIPT_ID);
}

/**
 * Add Amazon Pay Button into DOM
 * @param amazonPreferences - preferences for amazon
 * @param buttonID - DOM element id to append the button
 */
export function addAmazonButton(amazonPreferences: any, buttonID: string): void {
	const btnConfig = getAmazonButtonConfig(amazonPreferences);
	(window as any).amazon.Pay.renderButton(`#${buttonID}`, btnConfig);
}

/**
 * Generates config for Amazon Pay button
 * @param amazonPreferences
 * @returns config for Amazon Pay button
 */
function getAmazonButtonConfig(amazonPreferences: any) {
	return {
		// set checkout environment
		merchantId: amazonPreferences.merchantId,
		publicKeyId: amazonPreferences.publicKeyId,
		ledgerCurrency: amazonPreferences.ledgerCurrency,
		// customize the buyer experience
		checkoutLanguage: amazonPreferences.language,
		productType: amazonPreferences.productType,
		placement: 'Cart',
		buttonColor: 'DarkGray',
		sandbox: amazonPreferences.sandboxMode,
		// configure Create Checkout Session request
		createCheckoutSessionConfig: {
			payloadJSON: amazonPreferences.payload, // string generated in step 2
			signature: amazonPreferences.signature, // signature generated in step 3,
			algorithm: 'AMZN-PAY-RSASSA-PSS-V2'
		},
	};
}

/**
 * Remove Amazon Pay script from the page
 */
export function removeAmazonPayScript(): void {
	document.getElementById(AMAZON_SCRIPT_ID)?.remove();
}
